export default {
    workOrder_main_tracker: "Work Orders",
    workOrder_main_customers: "Customers",
    workOrder_main_schedule: "Schedule",
};